export enum TripStatus {
  created = 100,
  assigned = 200,
  // inProcess = 3,
  closed = 400,
  expired = 500,
}
